import { Component, OnInit } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-anim-topology',
  templateUrl: './anim-topology.component.html',
  styleUrls: ['./anim-topology.component.scss']
})
export class AnimTopologyComponent implements OnInit {
  tlTopo = gsap.timeline({ repeat: -1 });

  paths = [
    { name: '.path.wave.merak-cyber', offset: 124 },
    { name: '.path.wave.cyber-cikampek', offset: 195 },
    { name: '.path.wave.cikampek-semarang', offset: 431 },
    { name: '.path.wave.semarang-surabaya', offset: 262 },
    { name: '.path.wave.surabaya-banyuwangi', offset: 165 },

    { name: '.path.wave.bogor-bandung', offset: 195 },
    { name: '.path.wave.bandung-solo', offset: 431 },
    { name: '.path.wave.solo-malang', offset: 262 },
    
    { name: '.path.wave.cyber-bogor', offset: 164 },
    { name: '.path.wave.cikampek-bandung', offset: 206 },
    { name: '.path.wave.bandung-cikampek', offset: 206 },
    { name: '.path.wave.cilacap-cirebon', offset: 171 },
    { name: '.path.wave.semarang-solo', offset: 162 },
    { name: '.path.wave.malang-surabaya', offset: 155 },
  ];

  constructor() { }

  ngOnInit(): void {
    this.animate();
  }

  ngOnDestroy(): void{
    this.tlTopo.kill();
  }

  animate() {
    // let tl = gsap.timeline({ repeat: -1 });

    this.tlTopo.add(this.animateNormalPath());
    this.tlTopo.add(this.animateBreakageSwitch());
    this.tlTopo.add(this.animateBreakagePath());
    this.tlTopo.add(this.animateEndBreakagePath(), '>-=1.25');
  }

  animateNormalPath() {
    let tl = gsap.timeline({ repeat: 3, defaults: { ease: 'none' } });
    
    tl.addLabel('start');


    tl.add(this.animatePath('merak-cyber', 1, 0), 'start').addLabel('endMerakCyber');
    tl.add(this.animatePath('cyber-bogor', 0.5, 0), 'endMerakCyber').addLabel('endCyberBogor');
    tl.add(this.animatePath('bogor-bandung', 0.5, 0), 'endCyberBogor').addLabel('endBogorBandung');
    tl.add(this.animatePath('cyber-cikampek', 1, 0), 'endMerakCyber').addLabel('endCyberCikampek');

    tl.add(this.animatePath('cikampek-semarang', 1.5, 0), 'endCyberCikampek').addLabel('endCikampekSemarang');
    tl.add(this.animatePath('bandung-solo', 1.5, 0), 'endBogorBandung').addLabel('endBandungSolo');

    tl.add(this.animatePath('solo-malang', 0.75, 0), 'endBandungSolo').addLabel('endSoloMalang');
    tl.add(this.animatePath('malang-surabaya', 0.75, 0), 'endSoloMalang').addLabel('endMalangSurabaya');
    tl.add(this.animatePath('semarang-surabaya', 1.6, 0), 'endCikampekSemarang').addLabel('endSemarangSurabaya');
    tl.add(this.animatePath('surabaya-banyuwangi', 0.5, 0), 'endSemarangSurabaya').addLabel('endSurabayaBanyuwangi');

    tl.add(this.animatePath('cikampek-bandung', 1.5, 0), 'start+=1');
    tl.add(this.animatePath('cilacap-cirebon', 1.5, 0), 'start+=1');
    tl.add(this.animatePath('semarang-solo', 1.5, 0), 'start+=1');

    tl.add(this.animatePath('cikampek-bandung', 2.5), 'start+=3');
    tl.add(this.animatePath('cilacap-cirebon', 2.5), 'start+=3');
    tl.add(this.animatePath('semarang-solo', 2.5), 'start+=3');

    tl.addLabel('startEndTail', 'endCyberCikampek+=0.75');
    tl.add(this.animatePath('merak-cyber', 0.75), 'startEndTail');
    tl.add(this.animatePath('cyber-bogor', 0.75), 'startEndTail');

    tl.add(this.animatePath('cyber-cikampek', 0.75), 'startEndTail+=0.75');
    tl.add(this.animatePath('bogor-bandung', 0.75), 'startEndTail+=0.75');

    tl.add(this.animatePath('cikampek-semarang', 2), 'startEndTail+=1.5');
    tl.add(this.animatePath('bandung-solo', 2), 'startEndTail+=1.5');

    tl.add(this.animatePath('semarang-surabaya', 0.5), 'startEndTail+=3.5');
    tl.add(this.animatePath('solo-malang', 0.5), 'startEndTail+=3.5');
    tl.add(this.animatePath('malang-surabaya', 0.25), 'startEndTail+=4');
    tl.add(this.animatePath('surabaya-banyuwangi', 0.5), 'startEndTail+=4.25');

    tl.to('.merak', { opacity: 1, duration: 2 });
    tl.duration(1.25);

    return tl;
  }

  animateBreakagePath() {
    let tl = gsap.timeline({ repeat: 11 });

    tl.addLabel('start');
    tl.add(this.animatePath('merak-cyber', 1, 0), 'start');
    tl.add(this.animatePath('cyber-bogor', 1, 0), 'start+=1');
    tl.add(this.animatePath('bogor-bandung', 1, 0), 'start+=2');
    tl.add(this.animatePath('bandung-cikampek', 1, 0), 'start+=3');
    tl.add(this.animatePath('cikampek-semarang', 2, 0), 'start+=4').addLabel('startEndTail');
    tl.add(this.animatePath('semarang-solo', 1, 0), 'start+=6');
    tl.add(this.animatePath('solo-malang', 1, 0), 'start+=7');
    tl.add(this.animatePath('malang-surabaya', 1, 0), 'start+=8');
    tl.add(this.animatePath('surabaya-banyuwangi', 0.5, 0), 'start+=9');

    // start endTail
    tl.add(this.animatePath('merak-cyber', 1), 'startEndTail');
    tl.add(this.animatePath('cyber-bogor', 1), 'startEndTail+=1');
    tl.add(this.animatePath('bogor-bandung', 1), 'startEndTail+=2');
    tl.add(this.animatePath('bandung-cikampek', 1), 'startEndTail+=3');
    tl.add(this.animatePath('cikampek-semarang', 2), 'startEndTail+=4');
    tl.add(this.animatePath('semarang-solo', 1), 'startEndTail+=6');
    tl.add(this.animatePath('solo-malang', 1), 'startEndTail+=7');
    tl.add(this.animatePath('malang-surabaya', 1), 'startEndTail+=8');
    tl.add(this.animatePath('surabaya-banyuwangi', 1), 'startEndTail+=9');

    tl.to('.merak', { opacity: 1, duration: 2 });
    tl.duration(1.25);

    return tl;
  }

  animateBreakageSwitch() {
    let tl = gsap.timeline();

    tl.addLabel('start');
    tl.to('.breakage-1', { opacity: 1, duration: 1 }, 'start')
      .from('.breakage-1 circle', { attr: { r: 11 }, duration: 1, repeat: 2}, 'start+=1');
    
    tl.to('.breakage-2', { opacity: 1, duration: 1 }, 'start+=0.5')
      .from('.breakage-2 circle', { attr: { r: 11 }, duration: 1, repeat: 2}, 'start+=1.5');
    
    tl.to('.breakage-3', { opacity: 1, duration: 1 }, 'start+=1')
      .from('.breakage-3 circle', { attr: { r: 11 }, duration: 1, repeat: 2}, 'start+=2');

    tl.to('.initiate-switch', { opacity: 1, duration: 1, repeat: 2 }, 'start+=2')

    return tl;
  }

  animateEndBreakagePath() {
    let tl = gsap.timeline();

    tl.to('.breakage-1', { opacity: 0, duration: 0.25 })    
    tl.to('.breakage-2', { opacity: 0, duration: 0.25 })
    tl.to('.breakage-3', { opacity: 0, duration: 0.25 })
    tl.to('.initiate-switch', { opacity: 0, duration: 0.25 })

    return tl;
  }

  /**
   * @param name path's name
   * @param duration animation duration
   * @param offset target offset. if null, assume target offset is initial offset * -1
   */
  animatePath(name, duration, offset = null) {
    let path = this.paths.find(x => x.name == '.path.wave.' + name);
    return gsap.to(path.name, {
      strokeDashoffset: offset == null ? -path.offset : offset,
      duration,
      onComplete: () => {
        if (offset == null) {
          gsap.set(path.name, {
            strokeDashoffset: path.offset
          });
        }
      }
    })
  }
}
